// interface themeProps {
// 	[key: string]: any;
// }

const theme: any = {
  palette: {
    dim: `rgba(34, 34, 34, 0.6)`,
    transparent: "transparent",
    primary: "#0F98AA",
    blue: "#376DCC",
    dblue: "#2E63BE",
    red: "#CF221D",
    jred: "#C92B51",
    jblack: "#4E4F55",
    dgray: "#8C8F98",
    mlgray: "#D7DAE2",
    lgray: "#E7E9F0",
    backgray: "#F7F7F7",
    divider: "#F6F6F6",
    input: "#D7DAE2",
    gray200: "#F7F7F7",
    gray300: "#EEEEEE",
    gray400: "#E2E2E2",
    light_purple: "rgba(31, 166, 184, 0.12)",
    mgray: [
      "rgba(181, 184, 194,1)",
      "rgba(181, 184, 194,0.8)",
      "rgba(181, 184, 194,0.6)",
      "rgba(181, 184, 194,0.4)",
      "rgba(181, 184, 194,0.2)",
    ],
    black: [
      "rgba(28,28,30,1)",
      "rgba(28,28,30,0.8)",
      "rgba(28,28,30,0.6)",
      "rgba(28,28,30,0.4)",
      "rgba(28,28,30,0.2)",
    ],
    gray: [
      "rgba(140, 143, 152, 1)",
      "rgba(140, 143, 152,0.8)",
      "rgba(140, 143, 152,0.6)",
      "rgba(140, 143, 152,0.4)",
      "rgba(140, 143, 152,0.2)",
    ],
    lightGray: [
      "rgba(181, 184, 194, 1)",
      "rgba(181, 184, 194,0.8)",
      "rgba(181, 184, 194,0.6)",
      "rgba(181, 184, 194,0.4)",
      "rgba(181, 184, 194,0.2)",
    ],
    white: [
      "rgba(255,255,255,1)",
      "rgba(255,255,255,0.8)",
      "rgba(255,255,255,0.6)",
      "rgba(255,255,255,0.4)",
      "rgba(255,255,255,0.2)",
    ],
  },
  typography: {
    h0: `
            font-size: 32px;
            line-height:38px;
        `,
    h1: `
            font-size: 28px;
            line-height:24px;
        `,
    h2: `
            font-size: 24px;
            line-height:24px;
        `,
    h3: `
            font-size: 20px;
            line-height:24px;
        `,
    h4: `
            font-size: 18px;
            line-height:24px;
        `,
    body: `
            font-size: 16px;
            line-height:24px;
        `,
    info: `
            font-size: 14px;
            line-height:24px;
        `,
    small: `font-size:12px;`,

    label: `
			font-size: 16px;
            
		`,
  },
};

Object.keys(theme.typography).forEach((key) => {
  theme.typography[`${key}_bold`] = `
        ${theme.typography[key]}
        font-weight: 600;`;
});

export default theme;

export enum ThemeColor {
  BLACK = "black",
  JBLACK = "jblack",
  WHITE = "white",
  GRAY = "gray",
  PRIMARY = "primary",
  RED = "red",
  JRED = "jred",
  BLUE = "blue",
  DBLUE = "dblue",
  DGRAY = "dgray",
  MGRAY = "mgray",
  MLGRAY = "mlgray",
  LGRAY = "lgray",
  GRAY200 = "gray200",
  GRAY300 = "gray300",
  GRAY400 = "gray400",
  LIGHT_PURPLE = "light_purple",
}

export enum TextSize {
  h1 = "h1",
  h2 = "h2",
  h3 = "h3",
  h4 = "h4",
  body = "body",
  info = "info",
}
